export default __webpack_public_path__ + "static/media/me-icon-active.9743b8ad.webp";